import { React } from "react";
import { Card, Image, Typography } from "antd";
import { EllipsisOutlined } from "@ant-design/icons";
import { Button } from "../../../components";

import HeaderImg from "../../../assets/user-header.jpg";
import SubHeaderImg from "../../../assets/user-subHeader.jpg";
import Signal from "../../../assets/signal.png";


const { Title } = Typography;

const Header = ({name, count}) => (
  <Card style={{ borderRadius: 20 }}>
    <div>
      <Image src={HeaderImg} />
    </div>
    <div className="p-6 block lg:flex justify-between items-end">
      <div className="flex">
        <div
          className="w-40 h-40 rounded-full block lg:flex overflow-hidden mr-5"
          style={{ marginTop: "-80px" }}
        >
          <Image src={SubHeaderImg} />
        </div>
        <div>
          <Title level={3}>{name}</Title>
          <div className="block lg:flex items-center justify-between mt-2">
            <Image src={Signal} />
            <p className="inline">{`${count} Mutual Friends`}</p>
          </div>
        </div>
      </div>
      <div className="text-left">
        <Button
          type="primary"
          className="mt-0 primary-color forumBtnActive"
          title="Following"
          style={{
            height: "50px",
            borderRadius: "30px",
            paddingLeft: "2.5em",
            paddingRight: "2.5em",
          }}
        />
        <div className="hidden lg:block">
          <EllipsisOutlined style={{ fontSize: "36px", color: "#000", marginLeft: 10 }} />
        </div>
      </div>
    </div>
  </Card>
);

export default Header;
